import axios from 'axios'
import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    show: false,
    baseUrl: (process.env.VUE_APP_KIGAGU_API_BASE_URL || 'https://api.kigagu.com/api'),
    brands: [],
    selectedBrands: [],
    categories: [],
    selectedCategories: [],
    content: [],
    searchKey: '',
    searchForm: {
      productContentId: '',
      variantBarcodes: '',
      barcode: '',
      productName: '',
      brandIds: [],
    },
  },
  getters: {
    _show(state) {
      return state.show
    },
    _searchKey(state) {
      return state.searchKey
    },
    _searchForm(state) {
      return state.searchForm
    },
    _brands(state) {
      return state.brands
    },
    _selectedBrands(state) {
      return state.selectedBrands
    },
    _categories(state) {
      return state.categories
    },
    _selectedCategories(state) {
      return state.selectedCategories
    },
    _content(state) {
      return state.content
    },
  },
  mutations: {
    setShow(state, show) {
      state.show = show
    },
    setSearchKey(state, searchKey) {
      state.searchKey = searchKey
    },
    setSearchForm(state, searchForm) {
      state.searchForm = searchForm
    },
    setBrands(state, brands) {
      state.brands = brands
    },
    addSelectedBrand(state, selectedBrand) {
      if (!state.selectedBrands.includes(selectedBrand)) {
        state.selectedBrands.push(selectedBrand)
      }
    },
    removeSelectedBrand(state, selectedBrand) {
      state.selectedBrands = state.selectedBrands.filter(brand => brand !== selectedBrand)
    },
    setCategories(state, categories) {
      state.categories = categories
    },
    addSelectedCategory(state, selectedCategory) {
      if (!state.selectedCategories.includes(selectedCategory)) {
        state.selectedCategories.push(selectedCategory)
      }
    },
    removeSelectedCategory(state, selectedCategory) {
      state.selectedCategories = state.selectedCategories.filter(category => category !== selectedCategory)
    },
    setContent(state, content) {
      state.content = content
    }
  },
  actions: {
    async setSearchFormBy(context, key) {
      context.commit('setSearchKey', key)
      const trendyolLink = (context.state.searchForm.productContentId || '').trim()
      const productContentId = trendyolLink.match(/(?:^|[-/])p-(\d+)/)?.[1] || ''
      const variantBarcodes = (context.state.searchForm.variantBarcodes || '').trim()
      const productName = (context.state.searchForm.productName || '').trim()
      const brandIds = context.state.searchForm.brandIds || []
      const barcode = (context.state.searchForm.barcode || '').trim()

      const params = {}
      if (key === 'productContentId' && productContentId) {
        params.productContentId = productContentId
      } else if (key === 'variantBarcodes' && variantBarcodes) {
        params.variantBarcodes = variantBarcodes
      } else if (key === 'productName' && productName) {
        params.productName = productName
      } else if (key === 'brandIds' && brandIds.length > 0) {
        params.brandIds = brandIds.join(',')
      } else if (key === 'barcode' && barcode) {
        params.barcode = barcode
      } else {
        Vue.swal({
          title: 'Gecersiz Arama',
          icon: 'warning',
          text: 'Lutfen gecerli bir arama kriteri giriniz.',
        })
        return
      }

      const baseUrl = context.state.baseUrl || ''
      const token = await context.dispatch('kigagu/ensureToken', null, { root: true })
      if (!token) {
        return
      }

      const refreshToken = context.rootGetters['store/_stores']?.find(s => s.id === 24)?.refresh_token_2

      if (!refreshToken) {
        Vue.swal({
          title: 'Token Hatasi',
          icon: 'error',
          text: 'Store id 24 icin refresh token bulunamadi.',
        })
        return
      }

      try {
        const res = await axios.get(`${baseUrl}/export/product/search-by/${key}/trendyol`, {
          params,
          headers: {
            Authorization: `Bearer ${token}`,
            'x-ty-code': refreshToken,
          },
        })
        const { data } = res
        context.commit('setContent', data.content)
        context.commit('setBrands', data.aggregations.brand)
        context.commit('setCategories', data.aggregations.category)
      } catch (error) {
        const statusCode = error?.response?.status
        Vue.swal({
          title: statusCode === 401 ? 'Yetki Hatasi' : 'Istek Hatasi',
          icon: 'error',
          text: statusCode === 401
            ? 'API istegi 401 dondu. Gecersiz veya suresi dolmus token olabilir.'
            : 'API istegi basarisiz oldu. Lutfen tekrar deneyiniz.',
        })
      }
    },
    setSearchFormByName(context) {
      alert(context.state.searchForm.productName)
    },
    clearSearch(context) {
      context.commit('setSearchForm', {
        productContentId: '',
        variantBarcodes: '',
        productName: '',
      })
    },
  },
}
